import classNames from 'classnames';
import { PropsWithChildren } from 'react';

const SidebarSection = ({ children, className }: PropsWithChildren & { className?: string }) => {
  return (
    <div className={classNames("px-4 my-2.5", className)}>
      {children}
    </div>
  );
};

export default SidebarSection;
